import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.9231 9.92312C9.9231 9.51234 10.0449 9.11079 10.2731 8.76924C10.5013 8.42769 10.8257 8.16149 11.2052 8.00429C11.5847 7.84709 12.0023 7.80596 12.4052 7.8861C12.8081 7.96624 13.1782 8.16405 13.4686 8.45451C13.7591 8.74497 13.9569 9.11504 14.037 9.51793C14.1172 9.92081 14.076 10.3384 13.9188 10.7179C13.7616 11.0974 13.4954 11.4218 13.1539 11.65C12.8123 11.8782 12.4108 12 12 12V13.3847",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15.4615C11.7946 15.4615 11.5938 15.5225 11.4231 15.6366C11.2523 15.7507 11.1192 15.9129 11.0406 16.1026C10.962 16.2924 10.9414 16.5012 10.9815 16.7026C11.0216 16.904 11.1205 17.0891 11.2657 17.2343C11.4109 17.3795 11.596 17.4784 11.7974 17.5185C11.9989 17.5586 12.2077 17.538 12.3974 17.4594C12.5872 17.3808 12.7494 17.2477 12.8635 17.0769C12.9776 16.9062 13.0385 16.7054 13.0385 16.5C13.0349 16.2257 12.9243 15.9636 12.7303 15.7697C12.5364 15.5757 12.2743 15.4651 12 15.4615Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgHelp);
export default ForwardRef;
